(function() {
    var freshopEvents = freshop.events = {},
        eventNs,
        allowedOnEvents = {
            INITIALIZED: true,
            LOADED: true, //remove this when Wordpress implements freshop.ui.events.LOADED (or most likely it can be switched to utilize freshop.events.INITIALIZED)

            SESSION_CHANGED: true,
            USER_LOADED: true, //remove this when Wordpress implements User Session Indicator module
            USER_CHANGED: true,

            SEARCH: true, //remove this when Wordpress implements freshop.ui.events.SEARCH

            STORE_LOADED: true, //remove this when Wordpress implements freshop.getCurrentStore (from INITIALIZED event)
            STORE_CHANGED: true,

            ROUTE_CHANGED: true, //remove this when Wordpress implements freshop.ui.events.ROUTE_CHANGED

            LIST_REFRESHED: true, //remove this when Wordpress implements Mini List Indicator module

            MINI_LIST_HIDDEN: true, //remove this when Wordpress implements Mini List Indicator module

            CIRCULAR_DISPLAY_TYPE_CHANGED: true //remove this if/when we come up with a better way to handle CIRCULAR_DISPLAY_TYPE_CHANGED event
        },
        allowedTriggerEvents = {
            MINI_LIST_SHOW: true, //remove this when Wordpress implements Mini List Indicator module
            MINI_LIST_HIDE: true, //remove this when Wordpress implements Mini List Indicator module

            MEDIA_WIDTH_CHANGE: true, //remove this when Wordpress implements freshop.ui.trigger(selector, 'resize')
            RESIZE: true //remove this when Wordpress implements freshop.ui.trigger(selector, 'resize')
        },
        on = {},
        trigger = {};

    fp.clientEvents = {
        on: on,
        trigger: trigger
    };

    _.each(allowedOnEvents, function(value, key) {
        if(_.isString(value)) eventNs = value;
        else eventNs = fp.events[key];

        freshopEvents[key] = eventNs;
        on[eventNs] = true;
    });

    _.each(allowedTriggerEvents, function(value, key) {
        if(_.isString(value)) eventNs = value;
        else eventNs = fp.events[key];

        freshopEvents[key] = eventNs;
        trigger[eventNs] = true;
    });
})();